import { render, staticRenderFns } from "./swert.vue?vue&type=template&id=13fc8286&"
import script from "./swert.vue?vue&type=script&lang=ts&"
export * from "./swert.vue?vue&type=script&lang=ts&"
import style0 from "./swert.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports